import React, { useEffect, useState } from 'react';
import { BellAlertIcon } from '@heroicons/react/24/outline';
import { MobileAlertTriggerProps } from '../types';

export const MobileAlertTrigger: React.FC<MobileAlertTriggerProps> = ({
  alertCount,
  onTrigger,
  className = '',
  variant = 'blue',
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (alertCount > 0) {
      setIsVisible(true);
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 500);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [alertCount]);

  if (!isVisible) return null;

  const colorVariants = {
    blue: {
      background: '#2196f3',
      shadow: 'rgba(33, 150, 243, 0.4)',
      shadowHover: 'rgba(33, 150, 243, 0.6)',
    },
    pink: {
      background: '#c5008f',
      shadow: 'rgba(197, 0, 143, 0.4)',
      shadowHover: 'rgba(197, 0, 143, 0.6)',
    },
  };

  const colors = colorVariants[variant];

  return (
    <button
      onClick={onTrigger}
      className={`mobile-alert-trigger ${className} ${isAnimating ? 'animate' : ''}`}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        background: colors.background,
        border: 'none',
        boxShadow: `0 4px 12px ${colors.shadow}`,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9998,
        transition: 'all 0.3s ease',
        color: 'white',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow = `0 6px 16px ${colors.shadowHover}`;
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = `0 4px 12px ${colors.shadow}`;
      }}
    >
      <div style={{ position: 'relative' }}>
        <BellAlertIcon className="w-6 h-6" />
        {alertCount > 0 && (
          <span
            style={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              background: '#f44336',
              color: 'white',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              animation: isAnimating ? 'pulse 0.5s ease-in-out' : 'none',
            }}
          >
            {alertCount > 9 ? '9+' : alertCount}
          </span>
        )}
      </div>

      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.2); }
          100% { transform: scale(1); }
        }
        
        .mobile-alert-trigger.animate {
          animation: bounce 0.5s ease-in-out;
        }
        
        @keyframes bounce {
          0%, 20%, 60%, 100% { transform: translateY(0); }
          40% { transform: translateY(-10px); }
          80% { transform: translateY(-5px); }
        }
      `}</style>
    </button>
  );
};
